import { render, staticRenderFns } from "./OpenPricing.vue?vue&type=template&id=15d0d723"
import script from "./OpenPricing.vue?vue&type=script&lang=js"
export * from "./OpenPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports